import { inject, Injectable } from '@angular/core'
import { IAuthService } from '@engineering11/auth-web'
import { BaseUserConfigProvider, IUserConfig } from '@engineering11/user-web'

@Injectable({ providedIn: 'root' })
export abstract class CnectUserConfigProvider extends BaseUserConfigProvider {
  abstract get config(): IUserConfig
  authService = inject(IAuthService)
}
